import { IExportColumnModel } from "../../../../../shared/models";

export const SourceReportsColumnList: IExportColumnModel[] = [
]